module.exports = __webpack_public_path__ + "img/gntech_detail.48e22bda.jpg";